/**
 * SparkLayer Shadow DOM Style Overrides
 * For styles that CSS variables don't support in v3.x
 *
 * Note: v4 (~2 months out) may require selector updates
 * https://docs.sparklayer.io/customising-design
 */

(() => {
  const hidePriceSummary =
    window.sparkOverrideSettings?.hidePriceSummary || false;

  const sparkStyles = `
  spark-product-card .spark-product-card .product-purchase-listing, .spark-product-card, .spark-product-card .product-purchase-listing {
    display: flex !important;
    flex-direction: column;
  }
  spark-product-card .spark-product-card .product-purchase-listing .product-quantity-wrap, spark-product-card .product-purchase-listing, .spark-product-card, .spark-product-card .product-purchase-listing {
    flex: 1;
  }
  .spark-product-card .product-purchase-listing {
    display: flex !important;
    flex-direction: column;
    justify-content: space-between;
  }
  .spark-product-card .quantity-selector-wrapper {
    height: unset
  }
  .spark-product-card .product-purchase-listing .product-quantity-wrap {
    order: 1
  }
  .product-purchase-listing .product-tiered-pricing {
    order: 2
  }
  .spark-product-card .button-purchase {
    order: 3
  }

    /* Tables */
    table.border-table-border,
    table.border {
      border: 4px solid #000000 !important;
    }

    table.border-table-border td,
    table.border-table-border th {
      border-bottom: 4px solid #000000 !important;
    }

    table.border-table-border tbody tr:last-child td {
      border-bottom: none !important;
    }

    th.font-medium {
      font-family: "Arial", sans-serif !important;
      font-size: 16px !important;
      font-weight: 700 !important;
      line-height: 1 !important;
      color: #000000 !important;
    }

    /* Quantity selector */
    .quantity-selector-wrapper {
      border-radius: 56px !important;
      border: 2px solid #18181B !important;
      overflow: hidden;
    }

    .btn-quantity-selector {
      background: #ffffff !important;
      color: #18181B !important;
      border: none !important;
      border-radius: 0 !important;
      box-shadow: none !important;
    }

    .input-quantity {
      border-left: 1px solid #18181B !important;
      border-right: 1px solid #18181B !important;
    }

    /* Buttons */
    .button-purchase {
      flex-wrap: nowrap !important;
      position: relative !important;
    }

    .button-purchase__variant-info {
      position: absolute !important;
      width: 100% !important;
      top: 100% !important;
      left: 0 !important;
    }

    .button-purchase > button,
    button.btn-small:not(.btn-quantity-selector) {
      box-shadow: 2px 4px 0px 0px #000 !important;
      font-size: 17px !important;
      font-weight: 400 !important;
      line-height: 1 !important;
      font-family: "Readex Pro", sans-serif !important;
      flex: 1 1 auto !important;
      width: 100% !important;
      padding: 14px 28px !important;
    }

    ${
      hidePriceSummary
        ? `
    /* Price summary */
    .price-summary {
      display: none !important;
    }
    `
        : ''
    }
  `;

  const injectStyles = (el) => {
    if (!el?.shadowRoot || el.shadowRoot.querySelector('[data-spark-override]'))
      return;
    const style = document.createElement('style');
    style.setAttribute('data-spark-override', 'true');
    style.textContent = sparkStyles;
    el.shadowRoot.appendChild(style);
  };

  const injectAll = () => {
    document
      .querySelectorAll('spark-pdp, spark-product-card')
      .forEach(injectStyles);
  };

  injectAll();
  new MutationObserver(injectAll).observe(document.body, {
    childList: true,
    subtree: true,
  });
})();
